module.exports = __webpack_public_path__ + "static/media/ic-maps-massage.33ccec68.svg";